export default "__VITE_ASSET__Bt9Gtfo0__"